module.exports = __webpack_public_path__ + "static/media/image.51f3c585.png";